module.exports = __webpack_public_path__ + "img/warehouse.8ab9173d.svg";